import axios from "axios";
import config from "../config/app.config";
import { setAuthorizationToken } from "../helpers/axios";

setAuthorizationToken();

const Apiauth = {
  chack_apilogin: async () => {
    const resData = {
      method: "get",
      url: `${config.apiURL}/api/v1/admin/chack_apilogin`,
      headers: {
        "Content-Type": "application/json",
      },
      // data:data
    };

    return await axios(resData);
  },

  getdata_keyapiserver: async () => {
    const resData = {
      method: "get",
      url: `${config.apiURL}/api/v1/admin/getdata_keyapi`,
      headers: {
        "Content-Type": "application/json",
      },
      // data: data
    };

    return await axios(resData);
  },

  // Placeholder for generating a new API key
  // You'll need to implement the corresponding backend endpoint
  generateNewApiKey: async () => {
    const resData = {
      method: "post", // Or 'get', depending on your API design
      url: `${config.apiURL}/api/v1/admin/generate_new_apikey`, // Example endpoint
      headers: {
        "Content-Type": "application/json",
      },
      // Include any necessary payload
    };
    return await axios(resData);
  },
  chack_uuid: async (data) => {
    const resData = {
      method: "post", // Or 'get', depending on your API design
      url: `${config.apiURL}/api/v1/admin/chack_uuid`, // Example endpoint
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
      // Include any necessary payload
    };
    return await axios(resData);
  },

  getData_memerchang: async () => {
    const resData = {
      method: "get", // Or 'get', depending on your API design
      url: `${config.apiURL}/api/v1/admin/getdata_memerchang`, // Example endpoint
      headers: {
        "Content-Type": "application/json",
      },
      // Include any necessary payload
    };
    return await axios(resData);
  },

  editAdmin: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/postEditAdmin`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    return await axios(resData);
  },
  getSelectMerchant: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/postalternateAdmin`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    return await axios(resData);
  },
  updateMerchantStatusAPI: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/updateMerchantStatus`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    return await axios(resData);
  },
  postRemoveMerchantAPI: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/removeMerchantAPI`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    return await axios(resData);
  },
  podtAddadmin: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/create-admin`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    return await axios(resData);
  },
  registerOwner: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/registerOwner`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    return await axios(resData);
  },
  getReset_2fadmin: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/retfa`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    return await axios(resData);
  },
  addRoles: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/addpermission`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    return await axios(resData);
  },
  addCustomer: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/create_Member`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    return await axios(resData);
  },
  editCustomer: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v2/merchans/editCustumer/${data?.customer_uuid}`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    return await axios(resData);
  },
  getRole: async () => {
    const resData = {
      method: "get",
      url: `${config.apiURL}/api/v1/admin/getalldata_Role`,
      headers: {
        "Content-Type": "application/json",
      },
      // data: data
    };

    return await axios(resData);
  },
  getalldata_memerchang: async () => {
    const resData = {
      method: "get",
      url: `${config.apiURL}/api/v1/admin/getalldata_memerchang`,
      headers: {
        "Content-Type": "application/json",
      },
      // data: data
    };

    return await axios(resData);
  },
  getDataPermissions: async () => {
    const resData = {
      method: "get",
      url: `${config.apiURL}/api/v1/admin/alldata_permissions`,
      headers: {
        "Content-Type": "application/json",
      },
      // data: data
    };

    return await axios(resData);
  },
  getActivity_system: async () => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/getActivity_system`,
      headers: {
        "Content-Type": "application/json",
      },
      // data: data
    };

    return await axios(resData);
  },
  getListStatement: async (data) => {
    const resData = {
      method: "get",
      url: `${config.apiURL}/api/v2/merchans/get_list_statement?page=${data.offset}&limit=${data.limit}`,
      headers: {
        "Content-Type": "application/json",
      },
      // data: data
    };

    return await axios(resData);
  },
  getCustomer: async (data) => {
    const resData = {
      method: "get",
      url: `${config.apiURL}/api/v1/admin/get_customer?page=${data.offset}&limit=${data.limit}`,
      headers: {
        "Content-Type": "application/json",
      },
      // data: data
    };

    return await axios(resData);
  },
  getProfileAdmin: async () => {
    const resData = {
      method: "get",
      url: `${config.apiURL}/api/v1/admin/getProfileAdmin`,
      headers: {
        "Content-Type": "application/json",
      },
      // data: data
    };

    return await axios(resData);
  },
  postChangPassword: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/changPassword`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    return await axios(resData);
  },
  editRole: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/editPermission`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    return await axios(resData);
  },
  deleteAdmin: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/deleteAdmin`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    return await axios(resData);
  },
  editPermission: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/editPermission`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    return await axios(resData);
  },
  searchTransaction: async (data) => {
    // const host = window.location.hostname;
    // let isHost = host === "localhost";
    // let url = !isHost ? config.apiURL : config.apiURLnof;
    // console.log(url);
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/search/getSearchDataTransaction`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    return await axios(resData);
  },
  postOverviewReportChart: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/postOverviewReportChart`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    return await axios(resData);
  },
  getBankAccountBalanceLogs: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/bank-account-balance-logs`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    return await axios(resData);
  },
  gerReportDaily: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/report_daily`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    return await axios(resData);
  },
  addMerchant: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/merchans/create_merchants`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    return await axios(resData);
  },
  getPaymentEasy: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/merchans/payment`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    return await axios(resData);
  },
  confirm_account: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v2/merchans/create_customers`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    return await axios(resData);
  },
  getUploadSlip2: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/verrifyslip`,
      data: data,
    };
    return await axios(resData);
  },
  getUploadSlip: async (data, options = {}) => {
    const headers = {
      "Content-Type": "multipart/form-data",
      ...options.headers,
    };

    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/verifyslip`,
      data: data,
      onUploadProgress: options.onUploadProgress,
      headers: {
        ...headers,
      },
    };
    return await axios(resData);
  },
  getUploadNoSlip: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/verifyslip`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    return await axios(resData);
  },
  getVerifyDeposit: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/verrify`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    return await axios(resData);
  },
  getUpdate_withdraw: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/update_withdraw`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    return await axios(resData);
  },

  getSearchCustomer: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/chack_uuid`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    return await axios(resData);
  },

  getDeleteCustomer: async (data) => {
    let { id } = data;
    const resData = {
      method: "delete",
      url: `${config.apiURL}/api/v1/admin/customers/${id}`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    return await axios(resData);
  },

  getSupportTicketAPI: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/support-ticket`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    return await axios(resData);
  },
  getDataTicket: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/getDataTicket`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data
    };

    return await axios(resData);
  },

  getDataVerifyCustomer: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/verify-customer-logs`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data
    };

    return await axios(resData);
  },

  getInvoiceList: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/invoice/list`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data
    };

    return await axios(resData);
  },
  updateInvoiceStatus: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/invoice/confirm-payment`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data
    };
    return await axios(resData);
  },
  getCreateInvoice: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/invoice/create`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data
    };
    return await axios(resData);
  },
  searchCustomerData: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/chack_uuid`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data
    };
    return await axios(resData);
  },

  clearCacheVerifyCustomer: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/remove-cache-account`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data
    };
    return await axios(resData);
  },


};
export default Apiauth;
